namespace advisorop.components.servicer {

    export class OrionModelMonitorController {
        dgData: Array<any>;
        advisoryFirmId: number;
        pageLen: number;
        issuesCount: number;
        showNeto: boolean = true;
        dg: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        mvDate: Date = null;
        accountId: number = 0;
        accountPopupTitle: string = "Account Notes";
        showAccountNotes: boolean = false;
        puAccountNotesPopupOptions: DevExpress.ui.dxPopupOptions;
        // grid instance
        dgInst: DevExpress.ui.dxDataGrid;

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#orionModelMonitorContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["servicerService", "generalService", "advisoryFirmApi"];
        constructor(
            private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.puAccountNotesPopupOptions = {
                deferRendering: false,
                width: 600,
                height: 400,
                contentTemplate: "accountNotesPopup",
                showTitle: true,
                dragEnabled: false,
                closeOnOutsideClick: false,
                bindingOptions: {
                    visible: "vm.showAccountNotes",
                    title: "vm.accountPopupTitle"
                },
                toolbarItems: [
                    {
                        widget: "dxButton",
                        location: "center",
                        toolbar: "bottom",
                        options: {
                            text: "Close",
                            onClick: () => {
                                this.closeNotes();
                            }
                        }
                    }
                ]
            };

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "OrionModelMonitor"
                },
                bindingOptions: {
                    dataSource: "vm.dgData",
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    pageSize: this.pageLen,
                    enabled: true
                },
                rowAlternationEnabled: true,
                //width: 1000,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgNegCashMonitor = e.component;
                },
                wordWrapEnabled: true,

                columns: [
                    { dataField: "accountId", caption: "", cellTemplate: "colActions", width: 60 },
                    { dataField: "accountNumber", caption: "Account Number", width: 120 },
                    { dataField: "accountName", caption: "Account Name", width: 300 },
                    { dataField: "startDate", caption: "Proposal Create Date", width: 80, dataType: 'date', format: 'shortDate' },
                    { dataField: "advisorNames", caption: "Advisor", width: 120 },
                    { dataField: "modelName", caption: "Model on AdvisorOp Proposal", width: 200 },
                    { dataField: "investmentPercentage", caption: "% on AdvisorOp Proposal", width: 80, format: { type: "percent", precision: 0 }, visible: false },
                    { dataField: "orionModelName", caption: "Model on Orion Account", width: 200 },
                    { dataField: "value", caption: "Total Value", format: { type: 'currency', precision: 0 }, width: 80 },
                    { dataField: "notes", caption: "Notes", width: 120 },
                    { dataField: "orionModelId", caption: "Orion Id", width: 80, visible: false }
                ],
                masterDetail: {
                    enabled: true,
                    template: "sleeves",
                    autoExpandAll: false
                },
                onCellPrepared: this.oncp
            };
        }

        /**
         * report: AssetAllocation, Holdings, Performance, Transactions
         * level: will always be A-account or S-sleeve account
         * */
        openReport = (report: string, level: string, account: any) => {
            console.log(`Report: ${report} Level ${level}, account: ${account}`);
            this.servicerService.calculateOrionParamsAsync(level, account.accountId).then(params => {
                this.servicerService.openOrionReport(report, params);
            });
        }
        
        showNotes = (account: any) => {
            console.log("Show notes for account: ", account);
            this.accountPopupTitle = `Account Notes - ${account.accountNumber} - ${account.accountName}`;
            this.showAccountNotes = true;
            this.accountId = account.accountId;
        }
        closeNotes = () => {
            this.accountId = 0;
            this.showAccountNotes = false;
            this.loadDgData();
        }

        oncp = function (e: any) {
            if (e.rowType === 'data' && e.column.command === 'expand') {
                if (!(e.row.data && e.row.data.sleeves && e.row.data.sleeves.length > 0)) {
                    e.cellElement.removeClass('dx-datagrid-expand');
                    e.cellElement.empty();
                }
            }
        }

        loadDgData() {

            this.mvDate = null;
            let rez: any;
            this.isInitializing = true;
            this.issuesCount = 0;

            if (this.advisoryFirmId && this.advisoryFirmId > 0) {
                rez = this.servicerService.getOrionModelMonitorData(this.advisoryFirmId);
            }

            rez.then(response => {
                this.dgData = response.data;
                if (this.dgData.length > 0) {
                    this.issuesCount = this.dgData.length;
                }
                this.isInitializing = false;
            }, err => this.isInitializing = false)
            .catch(err => {
                this.generalService.showError(err);
            });
        };

        firmChanged(): void {
            this.advisoryFirmId = this.selFirm.id;
            this.loadDgData();
        }

        $onInit(): void {
            this.advisoryFirmApi.getAdvisoryFirmsLight().then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        }

        $onChanges(evt) {
            for (var key in evt) {
                //if (key === "advisoryFirmId" && this.advisoryFirmId) {
                //    console.log("Cash Monitor details data: ");
                //    console.log(this.dgData);
                //}
            }
        };
    }


    class OrionModelMonitor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<",
                pageLen: "<",
                issuesCount: "="
            };
            this.controller = OrionModelMonitorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/orion-model-monitor.html";
        }
    }
    angular.module(Constants.APP).component("orionModelMonitor", new OrionModelMonitor());

}